import React, { createContext, useContext, useState } from "react";

// Create the Cart Context
const CartContext = createContext();

// Cart Provider Component
export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartCount, setCartCount] = useState(0);

  const addToCart = (item) => {
    setCartItems((prevItems) => [...prevItems, item]);
  };

  const removeFromCart = (itemId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== itemId));
    setCartCount((prevCount) => prevCount - 1);
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const handleCount = () => {
    // Function to simulate adding items to the cart
    setCartCount((prevCount) => prevCount + 1);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartCount,
        handleCount,
        addToCart,
        removeFromCart,
        clearCart,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

// Hook to use Cart Context
export const useCart = () => {
  return useContext(CartContext);
};
